import img_url_gansu from "@/assets/gansudanbao.png";
import img_url_jinkong from "@/assets/gansujinkong.png";
import img_url_hanhua from "@/assets/hanhuadanbao.png";
import img_url_lanzhou from "@/assets/lanzhouBank.png";
import img_url_picc from "@/assets/picc.png";
import img_url_nongye from "@/assets/img_url_nongye.png";
import img_url_huanghe from "@/assets/img_url_huanghe.png";
export let guaranteeAgencys = {
    0: {
        label: "gansu",
        text: "甘肃担保",
        cateid: 0,
        img: img_url_gansu
    },
    1: {
        label: "hanhua",
        text: "瀚华担保",
        cateid: 1,
        img: img_url_hanhua
    },
    2: {
        label: "lanzhou",
        text: "兰州银行",
        cateid: 2,
        img: img_url_lanzhou
    },
    3: {
        label: "picc",
        text: "中国人保",
        cateid: 3,
        img: img_url_picc
    },
    17: {
        label: "jinkong",
        text: "甘肃金控",
        cateid: 17,
        img: img_url_jinkong
    },
    5: {
        label: "nongye",
        text: "中国农业银行",
        cateid: 5,
        img: img_url_nongye
    },
    4: {
        label: "huanghe",
        text: "黄河财险", // 黄河非车险保险公司
        cateid: 4,
        img: img_url_huanghe
    }
}